import styled from 'styled-components';

import { FIELD_MIN_PX } from '../GameListFilter/GameListFilter.styles';
import { LISTS_META_LINE_PX, LISTS_TITLE_LINE_PX } from '../GameLists/GameLists.styles';
import { COLORS, MOBILE, SPACE } from '@/nova/theme/tokens';

/* The page's name and its count of lists: each placeholder on a line as tall as the real one's. */
export const TitleLine = styled.span`
  display: flex;
  align-items: center;
  height: ${LISTS_TITLE_LINE_PX}px;
`;

export const MetaLine = styled.span`
  display: flex;
  align-items: center;
  height: ${LISTS_META_LINE_PX}px;
`;

/* A list's row: its name's place at the left, its count's at the right, as tall as the row (ListRow). */
export const ListRowSlot = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${SPACE[8]};
  min-height: 40px;
  padding: ${SPACE[0]} ${SPACE[12]};
`;

/* Drilled down, the open list's own row under its heading: its search, then its actions at the right (GameListGrid's
   filter row). */
export const FilterRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`;

/* The filter field's place (GameListFilter's Bar). */
export const Field = styled.div`
  flex: 1 1 ${FIELD_MIN_PX}px;
  min-width: 0;
  max-width: 560px;

  ${MOBILE} {
    max-width: none;
  }
`;

/* A game on a desktop: its square artwork, its name under it, then its ID and provider (GameListGrid's tile). */
export const Tile = styled.div`
  min-width: 0;
`;

export const TileArt = styled.div`
  aspect-ratio: 1 / 1;
`;

/* The name's two lines, as the tile always keeps them (13px, line-height 1.25). */
export const TileName = styled.div`
  height: 2.5em;
  margin: ${SPACE[8]} ${SPACE[2]} 0;
  font-size: 13px;
`;

export const TileMeta = styled.div`
  display: flex;
  align-items: center;
  min-height: 22px;
  padding: ${SPACE[4]} ${SPACE[2]} 0;
`;

/* A game on a phone: one slim row (GameListRows' row), its handle's room at the left, then its position, its
   thumbnail, and its name over its ID and provider. The 6px gap is that row's own, so the thumbnail and the name
   sit where the row's will. */
export const Row = styled.li`
  display: flex;
  align-items: center;
  gap: 6px;
  box-sizing: border-box;
  height: 52px;
  padding: 0 ${SPACE[16]} 0 ${SPACE[40]};
  border-radius: 12px;
  border: 1px solid ${COLORS.hairline};
  background: ${COLORS.surfaceCard};
`;

/* The position's room (GameListRows' Position), its number's block centred in it. */
export const RowPosition = styled.span`
  flex: none;
  display: inline-flex;
  justify-content: center;
  width: 22px;
`;

export const RowText = styled.div`
  flex: 1 1 auto;
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${SPACE[8]};
`;
